<h3 mat-dialog-title>Cadastrar Histórico de ativo do cliente</h3>

<div mat-dialog-content>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">

            <mat-form-field style="width: 100%" appearance="outline" floatLabel="always">
                <mat-label>Data</mat-label>
                <input 
                    matInput 
                    [matDatepicker]="picker" 
                    [formControl]="data_historico" 
                    name="data_historico" 
                    required
                    placeholder="Data"
                    [readonly]="!novoCadastro">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            
            <mat-form-field style="width: 100%" appearance="outline" *ngIf="!novoCadastro">
                <mat-label>Ativo</mat-label>
                <input 
                    matInput 
                    placeholder="Ativo" 
                    [formControl]="ativo"
                    readonly
                    maxlength="255"
                    [readonly]="!novoCadastro">                
            </mat-form-field>

            <mat-form-field style="width: 100%" appearance="outline" floatLabel="always">
                <mat-label>Tipo de Ativo</mat-label>
                <mat-select 
                    required 
                    [(ngModel)]="model.tipo_ativo" 
                    [formControl]="tipo_ativo" 
                    name="tipo_ativo"
                    [disabled]="!novoCadastro">
                    <mat-option value="B">Bolsa</mat-option>
                    <mat-option value="F">Opção Flexível</mat-option>
                    <mat-option value="D">Dividendos</mat-option>
                    <mat-option value="I">JCP</mat-option>
                </mat-select>
            </mat-form-field>
            
            <mat-form-field style="width: 100%" appearance="outline" *ngIf="novoCadastro">
                <mat-label>Ativo</mat-label>
                <input 
                    matInput 
                    placeholder="Digite o ativo" 
                    aria-label="Ativo"  
                    [formControl]="ativo" 
                    name="ativo" 
                    [matAutocomplete]="auto2"
                    [readonly]="!novoCadastro">
                <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFnAtivo"  (optionSelected)='getAtivo($event.option.value)'>
                    <mat-option *ngFor="let ativo of filteredOptionsAtivo | async" [value]="ativo">
                        <span>Empresa: {{ativo.nome}}</span> |
                        <small>Sigla: {{ativo.sigla }}</small>
                    </mat-option>
                </mat-autocomplete>            
                <mat-spinner diameter="20" *ngIf="loadingSpinnerAtivos"></mat-spinner>
            </mat-form-field>      
            
            <mat-form-field style="width: 100%" appearance="outline" floatLabel="always">
                <mat-label>Operação</mat-label>
                <mat-select 
                    required 
                    [(ngModel)]="model.tipo" 
                    [formControl]="tipo" 
                    name="tipo"
                    [disabled]="!novoCadastro">
                    <mat-option value="">SELECIONE</mat-option> 
                    <mat-option value="C">Compra</mat-option> 
                    <mat-option value="V">Venda</mat-option>
                    <mat-option value="E">Exercício</mat-option>
                    <mat-option value="D">Crédito</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field style="width: 100%" appearance="outline">
                <mat-label>Quantidade</mat-label>
                <input 
                    matInput 
                    placeholder="Quantidade" 
                    [formControl]="qtd" 
                    required
                    maxlength="20"
                    style="text-align: right;"
                    (ngModelChange)="montaValor()"
                    [readonly]="!novoCadastro">       
                <mat-error *ngIf="qtd.invalid">{{getErrorQtdMessage()}}</mat-error>         
            </mat-form-field>

            <mat-form-field style="width: 100%" appearance="outline">
                <mat-label>Preço Executado</mat-label>
                <input 
                    matInput 
                    placeholder="Preço Executado" 
                    [formControl]="preco_executado" 
                    required
                    currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    maxlength="50"                    
                    (ngModelChange)="montaValor()"
                    [readonly]="!novoCadastro">                    
            </mat-form-field>

            <mat-form-field style="width: 100%" appearance="outline">
                <mat-label>Valor Financeiro</mat-label>
                <input 
                    matInput 
                    placeholder="Valor Financeiro" 
                    [formControl]="vlr_financeiro"                     
                    currencyMask 
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    maxlength="50"
                    [readonly]="!novoCadastro">
                <mat-error *ngIf="vlr_financeiro.invalid">{{getErrorFinanceiroMessage()}}</mat-error>
            </mat-form-field>

            <mat-form-field style="width: 100%" appearance="outline"  *ngIf="user.role_id == 2 || user.role_id == 4 || user.role_id == 7">
                <mat-label>Corretagem</mat-label>
                <input 
                    matInput 
                    placeholder="Corretagem" 
                    [formControl]="corretagem"                     
                    currencyMask 
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    maxlength="50">                
            </mat-form-field>

            <div fxLayout="row" fxLayoutAlign="space-between" >
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                    <mat-label>Estratégia</mat-label>
                    <mat-select 
                        placeholder="Estratégia"
                        [(value)]="model.estrategia_id" 
                        [formControl]="estrategia_id"                                            
                        name="estrategia_id" >
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option 
                            *ngFor="let estrategia of listEstrategia" 
                            [value]="estrategia.id"
                        >
                            {{estrategia.nome}}
                        </mat-option>
                    </mat-select>
                    <mat-spinner diameter="20" *ngIf="loadingSpinnerEstrategia"></mat-spinner>
                </mat-form-field>
            </div>   
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button [disabled]="isInvalidForm()" (click)="salvar()" tabindex="-1">Salvar</button>
</div>